import React, { useState, useContext, useMemo } from "react";
import { Card, Button, Table, Modal, Form } from "react-bootstrap";
import { DashboardContext } from "../../../contexts/AdminContext";
import UserForm from "../forms/UserForm";
import "./css/Users.css";

const UsersTab = () => {
  const { users, loading, deleteUser } = useContext(DashboardContext);

  // ✅ STABIL: safeUsers tidak berubah tiap render
  const safeUsers = useMemo(() => {
    return Array.isArray(users) ? users : [];
  }, [users]);

  // 🔒 PASTIKAN users ARRAY
  const [showUserModal, setShowUserModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const [selectedRole, setSelectedRole] = useState("all");

  /* ===============================
     ROLE LIST
  ================================ */
  const availableRoles = useMemo(() => {
    const roleSet = new Set(safeUsers.map((user) => user.role));
    return Array.from(roleSet);
  }, [safeUsers]);

  /* ===============================
     FILTER USERS
  ================================ */
  const filteredUsers = useMemo(() => {
    if (selectedRole === "all") return safeUsers;
    return safeUsers.filter((user) => user.role === selectedRole);
  }, [safeUsers, selectedRole]);

  /* ===============================
     HANDLERS
  ================================ */
  const handleAddClick = () => {
    setEditingUser(null);
    setShowUserModal(true);
  };

  const handleEditClick = (user) => {
    setEditingUser(user);
    setShowUserModal(true);
  };

  const handleDeleteClick = (user) => {
    setUserToDelete(user);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (userToDelete) {
      // 🔥 MYSQL → pakai id, BUKAN _id
      const result = await deleteUser(userToDelete.id);
      if (result?.success) {
        setShowDeleteModal(false);
        setUserToDelete(null);
      }
    }
  };

  if (loading) return <div>Memuat data...</div>;

  /* ===============================
     RENDER
  ================================ */
  return (
    <div
      className="users"
      style={{ marginTop: "-15px", height: "calc(108vh - 120px)" }}
    >
      <Card className="shadow-sm">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <span style={{ fontSize: "35px" }}>Manajemen Pengguna</span>

          <div className="d-flex align-items-center">
            <Form.Select
              size="sm"
              value={selectedRole}
              onChange={(e) => setSelectedRole(e.target.value)}
              className="me-3"
              style={{ minWidth: "200px", height: "35px" }}
            >
              <option value="all">Semua Role</option>
              {availableRoles.map((role) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </Form.Select>

            <Button
              size="sm"
              onClick={handleAddClick}
              style={{ height: "35px" }}
            >
              Tambah
            </Button>
          </div>
        </Card.Header>

        <Card.Body>
          <div className="table-wrapper">
            <table className="preview-table">
              <thead>
                <tr>
                  <th
                    className="text-center"
                    style={{ background: "#1e3a8a", color: "#fff" }}
                  >
                    No
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Username
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>Role</th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>Aksi</th>
                </tr>
              </thead>

              <tbody>
                {filteredUsers.map((user, index) => (
                  <tr key={user.id}>
                    <td className="text-center">{index + 1}</td>
                    <td className="cell-left">{user.username}</td>
                    <td>{user.role}</td>
                    <td>
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="me-2"
                        onClick={() => handleEditClick(user)}
                      >
                        Edit
                      </Button>
                      <Button
                        size="sm"
                        variant="outline-danger"
                        onClick={() => handleDeleteClick(user)}
                      >
                        Hapus
                      </Button>
                    </td>
                  </tr>
                ))}

                {filteredUsers.length === 0 && (
                  <tr>
                    <td colSpan="4" className="text-center">
                      Tidak ada pengguna
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Card.Body>
      </Card>

      <UserForm
        show={showUserModal}
        handleClose={() => setShowUserModal(false)}
        initialData={editingUser}
      />

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Konfirmasi Hapus</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Yakin ingin menghapus <strong>{userToDelete?.username}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Batal
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Hapus
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UsersTab;
